function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export async function odtToHtml(bytes: Uint8Array): Promise<string> {
  const jszipMod = await import('jszip');
  const zip = await jszipMod.default.loadAsync(bytes);
  const contentFile = zip.file('content.xml');
  if (!contentFile) throw new Error('missing_content_xml');
  const xml = await contentFile.async('string');
  return contentXmlToHtml(xml);
}

export function contentXmlToHtml(xml: string): string {
  const doc = new DOMParser().parseFromString(xml, 'application/xml');
  const body = doc.querySelector('office\\:body, body');
  const text = body?.querySelector('office\\:text, text') ?? body;
  if (!text) return wrapHtml('<p>(empty document)</p>');

  const parts: string[] = [];
  for (const child of Array.from(text.children)) {
    const local = child.localName;
    if (local === 'h') {
      const level = child.getAttribute('outline-level') ?? '1';
      parts.push(`<h${level}>${inlineText(child)}</h${level}>`);
    } else if (local === 'p') {
      parts.push(`<p>${inlineText(child)}</p>`);
    } else if (local === 'table') {
      parts.push(renderTable(child));
    }
  }
  return wrapHtml(parts.join('\n') || '<p>(empty document)</p>');
}

function renderTable(table: Element): string {
  const rows = Array.from(table.querySelectorAll('table-row, table\\:table-row'));
  const htmlRows = rows.map((row) => {
    const cells = Array.from(row.querySelectorAll('table-cell, table\\:table-cell'))
      .map((cell) => `<td>${inlineText(cell)}</td>`)
      .join('');
    return `<tr>${cells}</tr>`;
  });
  return `<table>${htmlRows.join('')}</table>`;
}

function inlineText(node: Element): string {
  const parts: string[] = [];
  for (const child of Array.from(node.childNodes)) {
    if (child.nodeType === Node.TEXT_NODE) {
      parts.push(escapeHtml(child.textContent ?? ''));
      continue;
    }
    if (child.nodeType !== Node.ELEMENT_NODE) continue;
    const el = child as Element;
    const local = el.localName;
    if (local === 's') {
      const style = el.getAttribute('text:style-name') ?? '';
      const text = inlineText(el);
      if (style.includes('Bold')) parts.push(`<strong>${text}</strong>`);
      else if (style.includes('Italic')) parts.push(`<em>${text}</em>`);
      else parts.push(text);
    } else if (local === 'line-break') {
      parts.push('<br>');
    } else {
      parts.push(inlineText(el));
    }
  }
  return parts.join('');
}

function wrapHtml(body: string): string {
  return `<!doctype html><html><head><meta charset="utf-8"><style>body{font-family:system-ui,sans-serif;line-height:1.5;padding:1rem}table{border-collapse:collapse;width:100%}td,th{border:1px solid #ccc;padding:.25rem .5rem}</style></head><body>${body}</body></html>`;
}
